// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
    /* tslint:disable */
    export const VERSION = {
    "dirty": true,
    "raw": "bd73a14-dirty",
    "hash": "bd73a14",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "bd73a14-dirty",
    "semverString": null,
    "version": "0.15.4",
    "buildtime": "2026-01-15T10:20:06.540Z",
    "branch": "master"
};
    /* tslint:enable */
    